import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useDocumentReportId } from './useDocumentReportId'

const document = graphql(`
  mutation DocumentReportEditPage_ArchiveDocumentReport(
    $documentReportId: ID!
  ) {
    changeDocumentStatus(documentId: $documentReportId, newStatus: archived) {
      ok
    }
  }
`)

export const useArchiveDocumentReportMutation = (
  options: MutationOptions<void, void> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const documentReportId = useDocumentReportId()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId },
      })

      const ok = result.changeDocumentStatus?.ok ?? false
      if (!ok) {
        throw new Error(t('archive_failed'))
      }
    },
    ...options,
  })
}
